<div class="layout-col full p-sm">
  <div class="p-sm">
    <!-- for alignment with padded content -->
    <h4 class="text-title-large">{{ 'bom.item.detail' | translate }}</h4>
  </div>
  <form #frm="ngForm" class="flex layout-col">
    <app-bom-item-detail class="flex" [bomItem]="bomItem$ | async"> </app-bom-item-detail>
  </form>

  <div class="layout-row place-end-center">
    <button mat-button mat-dialog-close>
      {{ 'actions.cancel' | translate }}
    </button>

    <button mat-button [mat-dialog-close]="bomItem$.getValue()" [disabled]="!frm.form.valid">
      {{ 'actions.ok' | translate }}
    </button>
  </div>
</div>
